import React, {Component} from 'react';
import FlexRow from './FlexRow';
import ExpandButton from './ExpandButton';
import "../../css/tableStyles.css";

class StandardTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clicked: false,
        }

        this.renderCutoff = this.renderCutoff.bind(this);
        this.renderAllRows = this.renderAllRows.bind(this);
        this.handleClicked = this.handleClicked.bind(this);

    }

    handleClicked() {
        this.setState({
            clicked: !this.state.clicked
        })
    }


    renderCutoff() {
        return (this.props.reports.slice(0, 5).map(item => <FlexRow item={item} key={item.Counter}/>))
    }

    renderAllRows() {
        return (this.props.reports.map(item => <FlexRow item={item} key={item.Counter}/>))
    }

    render() {
        const reports = this.props.reports;
        let cutoff = this.props.reports.length > 5 ? true : false;

        if (reports.length > 0) {
            return (
                <div>
                    <div className="tableTitle">
                        <div className="legend">
                            <div className="legenditem"><span className="dataorigin ieq"></span>District environmental maintenance reports</div>
                            <div className="legenditem"><span className="dataorigin sms"></span>Six-month building surveys</div>
                        </div>
                    </div>
                    <div className={"table-wrap " + (this.props.classname)}>
                        <div className="flexTable">
                            <div className="flexTableHead">
                                <div className="flexCell">Location</div>
                                <div className="flexCell">Description</div>
                                <div className="flexCell">Date Issued</div>
                            </div>

                            {
                                (() => {
                                    if (cutoff && !this.state.clicked) {
                                        return this.renderCutoff()
                                    } else if (cutoff && this.state.clicke) {
                                        return this.renderAllRows()
                                    } else {
                                        return this.renderAllRows()
                                    }
                                })()
                            }
                            {
                                (() => {
                                    if(reports.length > 5) {
                                    return (<ExpandButton length={this.props.reports.length} clicked={this.state.clicked} onStateChange={this.handleClicked}/>)
                                }
                            })()
                            }

                        </div>

                    </div>
                </div>
            )
        }
        else {
            return (
                <div>
                    {/* <div className="tableTitle">District surveillance and maintenance reports:

                        </div>
                        <div className="noreports">
                        No reports
                    </div> */}
                </div>
            )
        }


    }
}

export default StandardTable;



// WEBPACK FOOTER //
// ./src/components/tables/StandardTable.js